export default __webpack_public_path__ + "static/media/home-bg2.1f7406dc.png";